import { Filter } from "@/modules/AvailabilityCalendar/models/AvailabilityFilter";

export const routes: Filter[] = [
  {
    value: "ABKI",
    label: "Aberdeen - Kirkwall",
  },
  {
    value: "ABLE",
    label: "Aberdeen - Lerwick",
  },
  {
    value: "KIAB",
    label: "Kirkwall - Aberdeen",
  },
  {
    value: "KILE",
    label: "Kirkwall - Lerwick",
  },
  {
    value: "LEAB",
    label: "Lerwick - Aberdeen",
  },
  {
    value: "LEKI",
    label: "Lerwick - Kirkwall",
  },
  {
    value: "SCST",
    label: "Scrabster - Stromness",
  },
  {
    value: "STSC",
    label: "Stromness - Scrabster",
  },
];

export const combinations = [];
